import React from 'react'
import { observer } from 'mobx-react'
import isEmpty from 'lodash/isEmpty'
import { action, observable } from 'mobx'
import { i18nTranslate } from 'src/utils'
import {
  subscriptionContainer,
  addressContainer,
  customerContainer,
} from 'src/models'
import { overlayState, toastState } from 'src/views/components'
import { ShippingDetailsCard } from './ShippingDetailsCard'
import { ShippingEditingModal } from './ShippingEditingModal'

@observer
class ShippingAddress extends React.Component {
  @observable isEditShippingAddress = false
  @observable showEditSubscriptionModal = false
  @observable disableShippingEdit = false
  @observable isShippingAddressCallInProgress = false
  @observable isShippingMethodCallInProgress = false
  @observable isAddressEditModal = false
  @observable editSubscriptionAddress = {}
  subscriptionShippingAddressId = ''
  selectedShippingAddressId = ''

  @action
  toggleEditSubscriptionValue = (e, id = 0) => {
    this.showEditSubscriptionModal = !this.showEditSubscriptionModal
    this.IDofCardToBeEdited = id
  }
  async componentDidMount() {
    await addressContainer.getProfileAddress()
  }
  renderShippingDetails = () => {
    const title = i18nTranslate(
      'subscription.shippingTitle',
      'Shipping Address'
    )
    const { addresses } = subscriptionContainer.subscriptionPreferenceResponse
    this.subscriptionShippingAddressId = addresses?.id || ''
    const name =
      addresses?.firstName && addresses?.lastName
        ? `${addresses.firstName} ${addresses.lastName}`
        : ''
    const streetName = `${addresses?.street1 || ''}${
      addresses?.street1 && addresses?.street2 ? ',' : ''
    } ${addresses?.street2 || ''}`

    const country =
      addresses?.city &&
      addresses?.state &&
      addresses?.zipCode &&
      addresses?.country
        ? `${addresses?.city}, ${
            addresses?.county ? addresses?.county + ',' : ''
          }${addresses?.state}, ${addresses?.zipCode}, ${addresses?.country}`
        : ''

    return (
      <div className="" data-testid="address-container">
        <ShippingDetailsCard
          details={{
            heading: title,
            line1: name,
            line2: streetName,
            line3: country,
            shippingInstruction:
              addresses?.properties?.deliveryInstruction || '',
            isFrom: 'address',
            event: this.handleEditShippingAddress,
          }}
        />
      </div>
    )
  }
  handleEditShippingAddress = () => {
    this.isEditShippingAddress = true
  }
  renderShippingAddress = (address = {}, isFromModal = false) => {
    const {
      addressLine1 = '',
      addressLine2 = '',
      street1 = '',
      street2 = '',
      city = '',
      county = '',
      state = '',
      zipCode = '',
      zip = '',
      // phone = '',
      country = '',
      properties,
      deliveryInstruction,
      firstName = '',
      lastName = '',
    } = address
    const actualZip = zipCode || zip
    return (
      <>
        <div
          className={` ${isFromModal ? 'd-flex' : 'shipping-section'} ${
            this.isEditShippingAddress ? '' : ' '
          }`}
          data-testid="qa-user-sub-shipping-address">
          {!isEmpty(address) ? (
            <p className="subscription-shipping-address paragraph-s pr-4">
              {[
                firstName,
                lastName,
                addressLine1,
                addressLine2,
                street1,
                street2,
                city,
                county,
                state,
                actualZip,
              ]
                .filter(item => item)
                .join(', ')}
              <br />
              {country || ''}
              <br />
              {deliveryInstruction && (
                <>
                  {i18nTranslate(
                    'shippingInstructions',
                    'Shipping instructions'
                  )}
                  {`: ${deliveryInstruction}`}
                </>
              )}
              {properties?.deliveryInstruction && (
                <>
                  <p className="shipping-text heading-6 m-0 pt-2">
                    {i18nTranslate(
                      'shippingInstructions',
                      'Shipping instructions'
                    )}
                    :
                  </p>
                  {properties?.deliveryInstruction}
                </>
              )}
              <br />
            </p>
          ) : (
            ''
          )}
          {isFromModal && !addressContainer.isRecommendationsVisible && (
            <p className="custom-alignment">
              <button
                tabIndex={0}
                onClick={() => this.handleSubscriptionAddressEdit(address)}
                className="custom-edit-link-button"
                data-testid="qa-subscription-address-edit">
                {i18nTranslate('edit', 'Edit')}
              </button>
            </p>
          )}
        </div>
      </>
    )
  }

  handleSubscriptionAddressEdit = address => {
    const toastMessage = i18nTranslate(
      'subscription.unabletoEditDelete',
      'Address is being used in your subscription order, so you are not allowed to Edit/Delete'
    )

    const isSubscriptionAddress =
      (this.subscriptionShippingAddressId == address?.addressId &&
        address?.properties?.isSubscriptionAddress) ||
      'false' === 'true'

    if (!isSubscriptionAddress) {
      this.editSubscriptionAddress = address
      this.isEditShippingAddress = !this.isEditShippingAddress
      this.isAddressEditModal = true
    } else {
      toastState.setToastMessage(toastMessage)
    }
  }

  updateSubscriptionAddress = async (
    data,
    isFromEditRadioOptionChange = false
  ) => {
    const updateSubscriptionResponse =
      await subscriptionContainer.updateSubscriptionsPreference(
        customerContainer.userId,
        data
      )
    if (subscriptionContainer.isSuccessResponse(updateSubscriptionResponse)) {
      isFromEditRadioOptionChange
        ? toastState.setToastMessage(
            i18nTranslate(
              'address.updateShippingAddressSuccessSetSubsDefault',
              'Shipping address updated successfully and set as subscription default'
            ),
            true
          )
        : toastState.setToastMessage(
            i18nTranslate(
              'address.updateAddressSuccess',
              'Your address has been updated.'
            ),
            true
          )
    } else {
      const isServiceFailure =
        updateSubscriptionResponse?.isServiceFailure || false
      const errorCode =
        updateSubscriptionResponse?.responseCode ||
        updateSubscriptionResponse?.code ||
        ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : updateSubscriptionResponse?.message ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      return toastState.setToastMessage(errorMessage, false)
    }
  }

  handleShippingSuggestionContinue = async (
    data,
    isFromModal,
    isRadioOptionChanged = false,
    validateAddressResponse = {},
    setDefaultShippingAddress = false
  ) => {
    this.isShippingAddressCallInProgress = true
    const { addresses } = subscriptionContainer.subscriptionPreferenceResponse
    this.newAddressToUpdate = data
    this.selectedShippingAddressId = data?.addressId || ''
    data.properties = {
      qasValidated: addressContainer.isQasValidated,
      selfValidated: addressContainer.isSelfValidated,
    }
    let response
    overlayState.toggleLoader()
    if (this.isEditShippingMethod) {
      response =
        await subscriptionContainer.getSubscriptionsPreferenceShippingMethods(
          customerContainer.userId,
          data
        )
    } else if (!isEmpty(addresses)) {
      response = await subscriptionContainer.getSubscriptionShippingAddress(
        customerContainer.userId,
        data
      )
    }
    const isSuccessValidate = addressContainer.isSuccessResponse(
      validateAddressResponse
    )

    if (
      (isEmpty(addresses) ||
        subscriptionContainer.isSuccessResponse(response)) &&
      isSuccessValidate &&
      !this.isAddressEditModal
    ) {
      this.subscriptionShippingAddressId =
        data.addressId || data.profileAddressId
      data.isDefault = this.editSubscriptionAddress.isDefault || true
      if (setDefaultShippingAddress || isRadioOptionChanged) {
        const isFromEditRadioOptionChange =
          isFromModal && isRadioOptionChanged ? true : false
        await this.updateSubscriptionAddress(data, isFromEditRadioOptionChange)
      }
      if (isRadioOptionChanged == true) {
        await addressContainer.updateProfileAddress(data, true)
      }
      this.isEditShippingAddress = false
      const { updateSubscription } = this.props
      updateSubscription && (await updateSubscription())
      subscriptionContainer.isSuggestionSelected = false
    } else if (this.isAddressEditModal) {
      data.addressId = this.editSubscriptionAddress.addressId
      this.subscriptionShippingAddressId = data.addressId
      data.isDefault = this.editSubscriptionAddress.isDefault // to trigger the kafka message if the edit address is default in address book
      if (setDefaultShippingAddress || isRadioOptionChanged) {
        const isFromEditRadioOptionChange =
          isFromModal && isRadioOptionChanged ? true : false
        await this.updateSubscriptionAddress(data, isFromEditRadioOptionChange)
      }
      const { updateSubscription } = this.props
      updateSubscription && (await updateSubscription())
      await addressContainer.updateProfileAddress(data, true)
      this.isAddressEditModal = false
      this.isEditShippingAddress = true
    } else {
      if (!isSuccessValidate) {
        if (validateAddressResponse.message) {
          toastState.setToastMessage(validateAddressResponse.message)
        }
      } else {
        const isServiceFailure = response?.isServiceFailure || false
        // const errorMessage = ''
        if (isServiceFailure) {
          toastState.setToastMessage(
            i18nTranslate(
              'subscription.somethingwentwrong',
              'Sorry, something went wrong. Please try again.'
            ),
            false
          )
        } else {
          if (response?.errors && isArray(response?.errors)) {
            if (response?.errors?.[0]) {
              toastState.setToastMessage(
                response?.errors?.[0]?.message ||
                  response?.errors?.[0]?.responseMessage
              )
            }
          } else {
            toastState.setToastMessage(
              response?.message || response?.responseMessage
            )
          }
        }
      }
    }
    overlayState.toggleLoader()
    this.isShippingAddressCallInProgress = false
  }

  renderShippingAddressEditingModal = () => {
    return (
      <ShippingEditingModal
        toggleEditSubscriptionValue={this.toggleEditSubscriptionValue}
        renderTabs={true}
        recommendations={addressContainer.addressData}
        customModalTitle={`${i18nTranslate(
          'subscription.shippingTitle',
          'Shipping Address'
        )}`}
        customSaveButtonLabel={`${i18nTranslate(
          'subscription.continue',
          'Continue'
        )}`}
        selectedId={this.subscriptionShippingAddressId}
        isForShippingAddress={true}
        toggleSuggestionView={() => {
          this.selectedShippingAddressId = ''
          this.isEditShippingAddress = false
        }}
        renderShippingAddressComponent={this.renderShippingAddress}
        toggleOnSubmit={false}
        handleAddressContinue={this.handleShippingSuggestionContinue}
      />
    )
  }

  render() {
    return (
      <div className="details-section">
        {this.renderShippingDetails()}
        {this.isAddressEditModal && (
          <ShippingEditingModal
            toggleEditSubscriptionValue={this.toggleEditSubscriptionValue}
            renderTabs={true}
            prefillData={this.editSubscriptionAddress}
            isExistingAddressEdit={true}
            toggleSuggestionView={() => {
              this.isAddressEditModal = false
            }}
            toggleOnSubmit={false}
            handleAddressContinue={this.handleShippingSuggestionContinue}
            renderShippingAddressComponent={this.renderShippingAddress}
          />
        )}
        {this.isEditShippingAddress && this.renderShippingAddressEditingModal()}
      </div>
    )
  }
}
export default ShippingAddress
export { ShippingAddress }
